import MuiSwitch, { SwitchProps } from '@mui/material/Switch'
import { switchStyles } from './Switch.styles'

/**
 * Everything MUI's Switch takes, plus the click handler this wrapper owns.
 * The rest was already forwarded — `checked`, `disabled` and the aria props all
 * reached MUI through the spread — the type just did not say so, which made a
 * controlled switch a type error.
 */
interface ExtendedSwitchProps extends Omit<SwitchProps, 'onClick' | 'sx'> {
  toggleSwitch: () => void
}

function Switch({ toggleSwitch, ...props }: ExtendedSwitchProps) {
  return (
    <MuiSwitch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      data-scroll-ignore
      onClick={() => toggleSwitch()}
      sx={switchStyles}
      {...props}
    />
  )
}

export default Switch
